import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const iconsRoute: RouteConfig<'with-page'> = {
    name: 'Icons',
    path: '/icons',
    icon: 'mdi mdi-emoticon-outline',
    page: lazy(() => import('.')),
    roles: ['developer'],
}